import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

import { ResultComponent } from './result/result.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { LayoutDefaultComponent } from './layout/default/default.component';
import { FullscreenComponent } from './layout/fullscreen/fullscreen.component';
import { NgxPermissionsModule } from 'ngx-permissions';

const COMPONENTS = [
  // page components
  DashboardComponent,
  LayoutDefaultComponent,
  FullscreenComponent,
  LoginComponent,
  ResultComponent
];

@NgModule({
  imports: [SharedModule, RoutesRoutingModule, NgxPermissionsModule.forChild()],
  declarations: [...COMPONENTS]
})
export class RoutesModule {}
